// components/PersonalizationFooter.tsx

import React from 'react';
import { AngleLeftIcon } from '@/utils/svgIcons';
import toast from 'react-hot-toast';
import CustomToast from '@/components/CustomToast';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

interface Option {
  id: string;
  label: string;
  value: string;
  completed: boolean;
}

interface Props {
  step: any;
  activeOption: any;
  options: any[];
  childName: any;
  is_edit: any;
  priceInPersonalize: any;
  inputs: any;
  inputValues: any;
  settings: any;
  setStep: any;
  setActiveOption: any;
  setConfirmCart: any;
  updateProductData: any;
  handleNextStep: any;
  handleSave: any;
  addToCart: any;
  setNormalizeModal: any;
  setPageTypeModal: any;
  setNoOfBooksModal: any;
  setNameModal: any;
}

const NotebookModalFooter: React.FC<Props> = ({
  step,
  activeOption,
  options,
  childName,
  is_edit,
  priceInPersonalize,
  inputs,
  inputValues,
  settings,
  setStep,
  setActiveOption,
  setConfirmCart,
  updateProductData,
  handleNextStep,
  handleSave,
  addToCart,
  setNormalizeModal,
  setPageTypeModal,
  setNoOfBooksModal,
  setNameModal,
}) => {
  const {t} = useTranslation('personalizeModal');
  const {locale} = useRouter();
  let totalOptions = options.length;
  let completedCount = options.filter(option => option.completed).length;
  return (
    <div className={`border-t px-4 ${(step === 'review') ? 'pb-6 lg:pb-4' : ''} bg-white shadow-[0_-2px_16px_0_rgba(14,30,37,0.3)] lg:flex lg:flex-col lg:items-center lg:justify-center`}>
        {(step != 'info' && step === 'review') && (
          <div className="w-full overflow-x-auto my-4 scrollbar-hide lg:max-w-6xl" dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
              <div className={`flex items-center justify-center gap-4 px-4 min-w-max lg:hidden`}>
            {options.map(opt => {
              return (
                <button
                  key={opt.id}
                  onClick={() => {
                    setStep('edit');
                    setActiveOption(opt.id);
                  }}
                  className={`h-20 w-full px-3 py-2 rounded-lg whitespace-nowrap text-sm font-normal flex flex-col justify-center items-start gap-2 ${
                    activeOption === opt.id || opt.completed
                      ? 'bg-[#0CDFBF] border-[1px] border-[#0CDFBF]'
                      : 'bg-white border-[1px] border-[#B0BAC8]'
                  }`}
                >
                  <p className='text-right mr-1 w-full'>{opt.label}</p>
                  <div className='flex items-center justify-start mx-auto gap-2 w-full'>
                    {opt.completed === true ? (
                      <div className='w-4 h-4 flex justify-center items-center bg-primary-500 rounded-full'>
                        <svg
                          width="12"
                          height="10"
                          viewBox="0 0 12 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 5.69922L3.70368 8.64736C4.1159 9.09686 4.83101 9.07584 5.21611 8.60291L11 1.5"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </div>
                    ) : (
                      <div
                        className={`w-4 h-4 rounded-full ${
                          activeOption === opt.id ? 'bg-[#FFFFFF]' : 'bg-[#0CDFBF]'
                        }`}
                      />
                    )}
                    <p className='text-base font-light line-clamp-1'>
                      {opt.value}
                    </p>
                  </div>
                </button>
              );
            })}
              </div>
              <div className='w-full flex items-center justify-center gap-4'>
                {/* for large device */}
                <div className={`hidden lg:flex gap-4 items-center w-3xl min-w-max ${locale === 'ar' ? '': 'ml-32'}`}>
              {options.map(opt => {
                return (
                  <button
                    key={opt.id}
                    onClick={() => {
                      if(opt.id === 'name')
                      {
                        setNameModal(true);
                      }
                      else if(opt.id === 'pageType')
                        setPageTypeModal(true);
                      else if(opt.id === 'noOfBooks')
                        setNoOfBooksModal(true)
                    }}
                    className={`h-16 w-full px-3 py-2 rounded-lg whitespace-nowrap text-sm font-normal flex flex-col justify-center items-start gap-2 ${
                      activeOption === opt.id || opt.completed
                        ? 'bg-[#0CDFBF] border-[1px] border-[#0CDFBF]'
                        : 'bg-white border-[1px] border-[#B0BAC8]'
                    }`}
                  >
                    <p className='text-right'>{opt.label}</p>
                    <div className='flex items-center justify-start mx-auto gap-2 w-full'>
                      {opt.completed === true ? (
                        <div className='w-4 h-4 flex justify-center items-center bg-primary-500 rounded-full'>
                          <svg
                            width="12"
                            height="10"
                            viewBox="0 0 12 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 5.69922L3.70368 8.64736C4.1159 9.09686 4.83101 9.07584 5.21611 8.60291L11 1.5"
                              stroke="white"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                        </div>
                      ) : (
                        <div
                          className={`w-4 h-4 rounded-full ${
                            activeOption === opt.id ? 'bg-[#FFFFFF]' : 'bg-[#0CDFBF]'
                          }`}
                        />
                      )}
                      <p className='text-base font-light line-clamp-1'>
                        {opt.value}
                      </p>
                    </div>
                  </button>
                );
              })}
              </div>
              <p className="hidden lg:block text-sm text-[#546A88]">
                {`(${completedCount}/${totalOptions})`}
              </p>
              </div>
          </div>
        )}
        {step !== 'info' && (
          <>
          {step !== 'edit' && (
            <p className="w-full flex items-center justify-center mb-2 lg:hidden text-sm text-[#546A88]">
              {`(${completedCount}/${totalOptions})`}
            </p>
          )}
          <button className={`w-full lg:hidden text-white p-3 rounded-md bg-primary ${step === 'review' ? 'my-0' : 'my-3'} font-medium`} onClick={()=>{
          if((step === 'edit') && (activeOption === 'name') ){
            if (childName === '' || !isNaN(Number(childName))) {
              toast.custom((tEl) => (
                <CustomToast type="error" t={tEl} message={`${t('enterChildNameNotebook')}`} />
              ));
              return;
            }
            updateProductData(
              Object.fromEntries(
                Object.keys(inputs)
                  .filter(key => {
                    const value = inputValues[key];
                    return value !== null && value !== undefined && String(value).trim() !== '';
                  })
                  .map(key => [key, inputValues[key]])
              )
            );
            handleNextStep();
            // setDedicationModal(true);
          }else if(step === 'edit' && activeOption === 'pageType'){
            // updateProductData({dedication: inputDedication});
            handleSave();
          }else if(step === 'edit' && activeOption === 'noOfBooks'){
            // updateProductData({cover: inputCover});
            handleSave();
          }else {
            if (options.every(option => option.completed) && is_edit === '0') {
              setConfirmCart(true);
            } else if (options.every(option => option.completed) && is_edit === '1') {
              addToCart();
            } else {
              const firstIncomplete = options.find(option => !option.completed);
              if (firstIncomplete) {
                const isMobileOrTablet = typeof window !== 'undefined' && window.innerWidth <= 1024;
                if (isMobileOrTablet) {
                  setStep('edit');
                  setActiveOption(firstIncomplete.id);
                } else {
                  if(firstIncomplete.id === 'pageType')
                    setPageTypeModal(true);
                  if(firstIncomplete.id === 'noOfBooks')
                    setNoOfBooksModal(true);
                } 
              }
            }
          }
        }}>
          {options.every(option => option.completed)
            ? is_edit === '1'
              ? `${t('completeEdit')}- ${priceInPersonalize}₪`
              : `${t('addToCartButtonText')} - ${priceInPersonalize}₪`
            : step === 'review' ? `${t('continue')} - ${priceInPersonalize}₪ `: `${t('continue')}`}
        </button>
          </>
        )}
          <div 
            className={`hidden lg:block w-full lg:max-w-xl text-white p-3 rounded-md bg-primary ${step === 'review' ? 'my-0' : 'my-3'} font-medium text-center cursor-pointer`}
            onClick={()=>{
              if(step === 'info' && is_edit === '0')
              {
                handleNextStep();
                return
              }
              if(step === 'edit' && is_edit === '1')
              {
                handleSave();
                return
              }
              if (options.every(option => option.completed) && is_edit === '0') {
              setConfirmCart(true);
              return
            } else if (options.every(option => option.completed) && is_edit === '1') {
              addToCart();
              return
            } else {
              const firstIncomplete = options.find(option => !option.completed);
              if (firstIncomplete) {
                const isMobileOrTablet = typeof window !== 'undefined' && window.innerWidth <= 1024;
                if (isMobileOrTablet) {
                  setStep('edit');
                  setActiveOption(firstIncomplete.id);
                } else {
                  if(firstIncomplete.id === 'pageType')
                    setPageTypeModal(true);
                  if(firstIncomplete.id === 'noOfBooks')
                    setNoOfBooksModal(true);
                } 
              }
            }
              // handleNextStep();
            }}
          >
            {options.every(option => option.completed)
            ? is_edit === '1'
              ? `${t('completeEdit')} - ${priceInPersonalize}₪`
              : `${t('addToCartButtonText')} - ${priceInPersonalize}₪`
            : (step === 'review') ? `${t('continue')} - ${priceInPersonalize}₪ `: `${t('continue')}`}
          </div>
        {(step === 'info' && (activeOption === '' || activeOption === 'name')) && (
          <button className={`block lg:hidden mb-4 mt-2 w-full lg:max-w-xl text-white p-4 rounded-md bg-primary font-medium`} onClick={()=>{
            const filledInputs = Object.keys(inputs).filter(key => {
              const value = inputValues[key];
              return value !== null && value !== undefined && String(value).trim() !== '';
            });

            if (filledInputs.length < Object.keys(inputs).length) {
              toast.custom(tel => (
                <CustomToast t={tel} type="error" message={`${t('enterAllDetailsError')}`} />
              ));
              return;
            }
            updateProductData(
              Object.fromEntries(
                Object.keys(inputs)
                  .filter(key => {
                    const value = inputValues[key];
                    return value !== null && value !== undefined && String(value).trim() !== '';
                  })
                  .map(key => [key, inputValues[key]])
              )
            );
            handleNextStep();
            }}>
            {`${t('continue')} - ${priceInPersonalize}₪ `}
        </button>
        )}
        {step !== 'edit' && (
          <button className="my-3 lg:my-4 text-primary-500 text-sm font-medium flex items-center justify-center w-full text-center" onClick={()=>setNormalizeModal(false)}>
                {t('infoStepBackButton')} 
                <span className="mr-3">
                    <AngleLeftIcon/>
                </span>
            </button>
        )}
      </div>
  );
};

export default NotebookModalFooter;
